module.exports = __webpack_public_path__ + "static/media/CARD_PREMIER@3x.80bb1d01.png";